import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { PageLink, PageTitle } from "_metronic/layout/core";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import CompanyBrandingForm from "./components/CompanyBrandingForm";
import ClientPortalLoginScreenForm from "./components/ClientPortalLoginScreenForm";

const companyBrandingBreadCrumbs: Array<PageLink> = [
  {
    title: "Company Branding",
    path: "/Admin/CompanyBranding",
    isSeparator: false,
    isActive: true,
  },
];

const CompanyBrandingPage = () => {
  return (
    <CPLAnalytics pageName="Company Branding">
      <PageTitle breadcrumbs={companyBrandingBreadCrumbs}></PageTitle>
      <CompanyBrandingForm></CompanyBrandingForm>
      <ClientPortalLoginScreenForm></ClientPortalLoginScreenForm>
    </CPLAnalytics>
  );
};

export default withAITracking(reactPlugin, CompanyBrandingPage, "Company Branding");
